module.exports = __webpack_public_path__ + "img/1.3e13f67e.jpg";